import { useMemo } from 'react'
import { FD_IMAGE_URL } from '../../../constants'
import { FDInvestmentJourneyResponseType } from '../../../types/fd-type'
import { ChevronBox } from '../ftux/ChevronBox'

export const FDDetailsStep = ({ data }: { data: FDInvestmentJourneyResponseType | undefined }) => {
  const detailsStep = useMemo(() => {
    return [
      {
        imgSrc: `${FD_IMAGE_URL}/ftux/grows-money-icon.svg`,
        text: `<span style="font-weight: 500;">${data?.interestRate}%</span> returns`
      },
      {
        imgSrc: `${FD_IMAGE_URL}/ftux/bolt-icon.svg`,
        text: `<span style="font-weight: 500;">${data?.planSecuredBy}</span>`
      },
      {
        imgSrc: `${FD_IMAGE_URL}/ftux/no-bank-acc-icon.svg`,
        text: `<span style="font-weight: 500;">Withdraw anytime</span> after ${data?.lockInPeriodInDays} days`
      }
    ]
  }, [data])

  return (
    <div className='flex flex-col px-5 w-full'>
      <div className='text-white text-[32px] font-[500] leading-[120%] text-center w-full'>
        Here’s why this FD is perfect for you
      </div>
      <div className='pt-8 w-full'>
        <div className='flex flex-col gap-3'>
          {detailsStep?.map((box, index) => {
            return (
              <ChevronBox key={`${box?.text}-${index}`} iconUrl={box?.imgSrc} text={box?.text} isActionable={false} />
            )
          })}
        </div>
      </div>
    </div>
  )
}
